<template>
  <div class="audio-media-box">
    <audio :id="showId" class="audio-media" :src="audioSource"></audio>
    <div class="audio-area" :class="{'isPlaying': isPlaying}" @click="playback">
      <p class="show-icon"><span :class="{'isPlaying': isPlaying}" class="circle"></span>
      </p>
      <p class="show-text">{{ audioText }}</p>
      <p class="show-time">{{ playedTime }} / {{ duration }}</p>
    </div>
  </div>
</template>

<script>
import {convertTimeMMSS} from '@/utils/audio'

export default {
  props: {
    src: {type: String},
    showId: {type: String},
  },
  data() {
    return {
      isPlaying: false,
      duration: convertTimeMMSS(0),
      playedTime: convertTimeMMSS(0),
      progress: 0,
    }
  },
  mounted() {
    this.player = document.getElementById(this.showId);
    // 可以自动播放时正确的事件顺序是
    // loadstart
    // loadedmetadata
    // loadeddata
    // canplay
    // play
    // playing
    //
    // 不能自动播放时触发的事件是
    // iPhone5  iOS 7.0.6 loadstart
    // iPhone6s iOS 9.1   loadstart -> loadedmetadata -> loadeddata -> canplay

    this.player.addEventListener('loadstart', () => {
      // console.log('loadstart');
    }, false);
    this.player.addEventListener('loadeddata', () => {
      // console.log('loadeddata');
    }, false);
    this.player.addEventListener('loadedmetadata', (ev) => {
      // console.log('loadedmetadata');
      this._resetProgress();
      this.duration = convertTimeMMSS(this.player.duration);
    }, false);
    this.player.addEventListener('canplay', () => {
      // console.log('canplay');
    }, false);

    this.player.addEventListener('ended', () => {
      this.playedTime = convertTimeMMSS(0);
      this.progress = 0;
      this.isPlaying = false;
    }, false);

    this.player.addEventListener('timeupdate', this._onTimeUpdate, false);
  },
  computed: {
    audioSource() {
      const url = this.src;
      if (url) {
        return url;
      } else {
        this._resetProgress();
      }
      return false;
    },
    audioText() {
      return this.isPlaying ? '暂停' : '播放';
    }
  },
  methods: {
    // forceSafariPlayAudio() {
    // 	this.player.load(); // iOS 9   还需要额外的 load 一下, 否则直接 play 无效
    // 	this.player.play(); // iOS 7/8 仅需要 play 一下
    // },
    playback() {
      if (!this.audioSource) {
        return
      }
      if (this.isPlaying) {
        this.player.pause();
      } else {
        setTimeout(() => {
          this.player.play();
        }, 10);
      }
      this.isPlaying = !this.isPlaying;
    },
    _resetProgress() {
      if (this.isPlaying) {
        this.player.pause();
      }
      this.duration = convertTimeMMSS(0);
      this.playedTime = convertTimeMMSS(0);
      this.progress = 0;
      this.isPlaying = false;
    },
    _onTimeUpdate() {
      this.playedTime = convertTimeMMSS(this.player.currentTime);
      this.progress = (this.player.currentTime / this.player.duration) * 100;
    },
    _onUpdateProgress(pos) {
      if (pos) {
        this.player.currentTime = pos * this.player.duration;
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.audio-media-box {
  width: 96%;
  height: 12vw;
  margin: 2vw 0;
  overflow: hidden;
  border-radius: 2vw;
  box-shadow: 0 0 10px #cfcfcf;
  .audio-media {
    display: none;
  }

  @keyframes opacityAnimation-left {
    20% {
      opacity: .2
    }
    100% {
      opacity: 1
    }
  }
  @keyframes opacityAnimation-center {
    40% {
      opacity: .4
    }
    100% {
      opacity: 1
    }
  }
  @keyframes opacityAnimation-right {
    60% {
      opacity: .5
    }
    100% {
      opacity: 1
    }
  }


  .audio-area {
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-align: center;
    //background: #33bd7d;
    border-radius: 2vw;
    border: 1px solid #36d0be;
    box-shadow: 0 0 6px rgba(0,0,0,.4);
    background: linear-gradient(45deg, #31c580 0, #25babd 100%) repeat scroll 0 0;
    cursor: pointer;

    &.isPlaying {
      background: linear-gradient(45deg, #25babd 0, #31c580 100%) repeat scroll 0 0;
    }

    p {
      height: 100%;
      line-height: 12vw;
      color: #fff;
    }

    .show-icon {
      flex: 0 0 18vw;
      display: flex;
      align-items: center;

      .circle {
        display: block;
        height: 8vw;
        width: 8vw;
        border: 1vw solid transparent;
        border-right-color: #fff;
        border-radius: 0 55% 55% 80%;
        position: relative;
        user-select: none;
        opacity: 1;

        &:before {
          content: '';
          position: absolute;
          left: -1vw;
          top: .2vw;
          height: 5.5vw;
          width: 5.5vw;
          border: 1vw solid transparent;
          border-right-color: #fff;
          border-radius: 0 55% 55% 80%;
          opacity: 1;
        }

        &:after {
          content: '';
          position: absolute;
          left: -.5vw;
          top: 1.7vw;
          height: 2.5vw;
          width: 2.5vw;
          border: 1vw solid transparent;
          border-right-color: #fff;
          border-radius: 0 55% 55% 80%;
          opacity: 1;
        }

        &.isPlaying {
          animation: opacityAnimation-right 1s ease-out infinite;

          &:before {
            animation: opacityAnimation-center 1s ease-out infinite;
          }

          &:after {
            animation: opacityAnimation-left 1s ease-out infinite;
          }
        }
      }
    }

    .show-text {
      flex: 1;
      font-size: 4vw;
    }

    .show-time {
      flex: 0 0 30vw;
      font-size: 4vw;
    }
  }
}
</style>
